import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Card from './Card';
import DescWithTitleAndIcon from './DescWithTitleAndIcon';

function ListOfDescriptionsAndCards({ cards, descriptions }) {
  const grid = {
    xs: 12,
    sm: 6,
  };

  const positions = ['offset-3 mb-5 z-index-5', 'z-index-3', 'mt-n6 offset-1 z-index-4'];

  return (
    <>
      <Col xs={12} lg={6} className="py-3">
        <Row>{cards && cards.map((item, index) => <Card key={index} index={index} positions={positions} item={item} />)}</Row>
      </Col>
      <Col xs={12} lg={6}>
        <Row>{descriptions && descriptions.map((item, index) => <DescWithTitleAndIcon key={index} item={item} grid={grid} />)}</Row>
      </Col>
    </>
  );
}

ListOfDescriptionsAndCards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      _key: PropTypes.string.isRequired,
    })
  ).isRequired,
  descriptions: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      image: PropTypes.shape({}).isRequired,
    })
  ).isRequired,
};

export default ListOfDescriptionsAndCards;
